module.exports = __webpack_public_path__ + "static/monitor-employees-attendance-and-availability-e01a2dbd238ff6304b45a0998c1421de.png";